<template>
  <div class="not-found">
    <div class="container not-found__inner">
      <h1 class="not-found__title">Página não encontrada</h1>
      <p class="not-found__text">
        O endereço que você acessou não existe ou foi movido.
      </p>
      <router-link to="/" class="btn btn--primary">Voltar ao início</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    metaInfo: {
      title: 'SEEB | Página não encontrada'
    }
  }
</script>

<style lang="scss" scoped>
.not-found {
  padding: clamp(80px, 12vw, 140px) 0;

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  &__title {
    margin: 0;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: var(--fs-h1);
    line-height: 1.05;
    letter-spacing: -0.02em;
    color: var(--c-navy);
  }

  &__text {
    margin: 0 0 12px;
    font-size: var(--fs-lead);
    color: var(--c-muted);
  }
}
</style>
